import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uvyajnxvs2: FaireBrandEntity = {
  token: "b_uvyajnxvs2",
  type: "brand",
  name: "Letters and Lucy",
  avatarUrl:
    "https://cdn.faire.com/fastly/9d717fb06b71e2456fcbb0a8235e03ee735fc55dd255bb4bd49b699e1bb374b0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dcfc5fb2f0e1f1c0c11cc9f2545fdc2f9c0d60894f6897cb5397bdb991a08531.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9d717fb06b71e2456fcbb0a8235e03ee735fc55dd255bb4bd49b699e1bb374b0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dcfc5fb2f0e1f1c0c11cc9f2545fdc2f9c0d60894f6897cb5397bdb991a08531.jpeg",
  location: "Amarillo, TX, USA",
  minimumOrderDollars: 69,
  rating: 4.4,
  reviewCount: 27,
  isInsider: true,
  description:
    "SHIPPING UPDATE! I recently had a baby so we had to increase our production time. But we are back to a normal schedule with our 5-10 days production time. Christmas Collection is ready to ship and will go out in a few days. \n\nLetters & Lucy was created from a passion for all things pop culture. It all began in January 2019 when I listed my first t-shirt design on Etsy. In just a few days, I received more orders than I ever could have imagined. The early success fueled my creativity and, thanks to inspiration from many late night reality TV binges, I continued to fill my shop with new designs. It wasn’t long until my shop got the attention of one of my favorite reality TV stars. When she posted a photo on Instagram in one of my shirts, I knew I was doing what I was always meant to do. With her support, Letters & Lucy grew from a side hustle to a full time job overnight. Now, I’m living my dream, doing what I love and surrounded by a community of strong, empowered women. ",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:10.045Z",
    importedBy: "entity-db-cli",
  },
};
